'use es6';

import { userInfoSync } from 'hub-http/userInfo';
import Raven from 'raven-js';
import * as storage from 'EmailData/lib/storage';
import { FETCH_HUB_SETTINGS_SUCCEEDED, FETCH_USER_ATTRIBUTES_SUCCEEDED } from 'ContentEditorUI/redux/actions/actionTypes';
import { OPEN_POPOVER, CLOSE_POPOVER } from 'ContentEditorUI/redux/actions/actionTypes';
import { POPOVERS } from 'EmailEditorUI/constants/PopoversConstants';
import { fetch } from 'EmailEditorUI/api/PaymentsEligibility';
import { getOpenedPopover } from 'EmailEditorUI/redux/selectors/AppStateSelectors';
import { CURRENT_USER_ATTRIBUTES_AS_ARRAY } from 'EmailEditorUI/constants/UserAttributesForEditor';
import { batchFetchUserAttributes, getStoredAttributesInLocalStorage } from 'EmailEditorUI/api/userAttributesApi';
import { getIsEmailTemplate } from 'EmailEditorUI/redux/selectors/emailCategoriesSelectors';
import { TOGGLE_APP_CLICK_CATCHER, TOGGLE_BRANDING_PQL, TOGGLE_EXIT_WITH_CHANGES_MODAL, FETCH_PAYMENT_ELIGIBILITY_STARTED, FETCH_PAYMENT_ELIGIBILITY_SUCCEEDED, FETCH_PAYMENT_ELIGIBILITY_FAILED } from 'EmailEditorUI/redux/actions/actionTypes';
import { HUB_SETTINGS_CACHE_KEY, LOCAL_STORAGE_BASE_KEY } from 'EmailEditorUI/constants/LocalStorageConstants';
import { updateUserAttributesLocalStorage } from 'EmailEditorUI/redux/actions/userActions';
import { batchFetchHubSettings } from 'EmailEditorUI/api/hubSettingApi';
import { HUB_SETTINGS_AS_ARRAY } from 'EmailEditorUI/constants/HubSettingsForEditor';
import { updateHubSettingsLocalStorage } from './userActions';
export const toggleAppClickCatcher = isVisible => ({
  type: TOGGLE_APP_CLICK_CATCHER,
  isVisible
});
export const toggleBrandingPql = isOpen => ({
  type: TOGGLE_BRANDING_PQL,
  isOpen
});
export const toggleExitWithChangesModal = isOpen => ({
  type: TOGGLE_EXIT_WITH_CHANGES_MODAL,
  isOpen
});
export const openPopover = popoverName => ({
  type: OPEN_POPOVER,
  popover: popoverName
});
export const closePopover = popoverName => ({
  type: CLOSE_POPOVER,
  popover: popoverName
});
export const makeTogglePopoverAction = popoverName => () => (dispatch, getState) => {
  if (getOpenedPopover(getState()) !== popoverName) {
    dispatch(openPopover(popoverName));
  } else {
    dispatch(closePopover(popoverName));
  }
};
export const togglePreviewPopover = makeTogglePopoverAction(POPOVERS.EMAIL_PREVIEW_BUTTON);
export const toggleEditorDisplayOptionsPopover = makeTogglePopoverAction(POPOVERS.EMAIL_EDITOR_DISPLAY_OPTIONS);
export const togglePreviewDisplayOptionsPopover = makeTogglePopoverAction(POPOVERS.EMAIL_PREVIEW_DISPLAY_OPTIONS);
export const fetchUserAttributes = () => (dispatch, getState) => {
  const state = getState();
  const {
    user,
    portal
  } = userInfoSync();
  const storedAttributes = getStoredAttributesInLocalStorage();
  if (storedAttributes) {
    dispatch({
      type: FETCH_USER_ATTRIBUTES_SUCCEEDED,
      attributes: storedAttributes
    });
  }
  batchFetchUserAttributes({
    keys: CURRENT_USER_ATTRIBUTES_AS_ARRAY,
    isTemplateEditor: getIsEmailTemplate(state)
  }).then(attributes => {
    updateUserAttributesLocalStorage(portal.portal_id, user.user_id, attributes);
    dispatch({
      type: FETCH_USER_ATTRIBUTES_SUCCEEDED,
      attributes
    });
  }).catch(error => {
    Raven.captureException(error);
  });
};
export const fetchHubSettings = () => (dispatch, getState) => {
  const state = getState();
  const {
    user,
    portal
  } = userInfoSync();
  const storedHubSettings = storage.get(portal.portal_id, LOCAL_STORAGE_BASE_KEY, HUB_SETTINGS_CACHE_KEY(user.user_id));
  const isTemplateEditor = getIsEmailTemplate(state);
  if (storedHubSettings) {
    dispatch({
      type: FETCH_HUB_SETTINGS_SUCCEEDED,
      settings: storedHubSettings
    });
  }
  batchFetchHubSettings(HUB_SETTINGS_AS_ARRAY, isTemplateEditor).then(hubSettings => {
    updateHubSettingsLocalStorage(portal.portal_id, user.user_id, hubSettings);
    dispatch({
      type: FETCH_HUB_SETTINGS_SUCCEEDED,
      settings: hubSettings
    });
  }).catch(error => Raven.captureException(error));
};
function requestPaymentsEligibility() {
  return {
    type: FETCH_PAYMENT_ELIGIBILITY_STARTED
  };
}
function receivePaymentsEligibility(response) {
  return {
    type: FETCH_PAYMENT_ELIGIBILITY_SUCCEEDED,
    response
  };
}
function receivePaymentsEligibilityFailure(error) {
  var _error$cause;
  if ((error === null || error === void 0 || (_error$cause = error.cause) === null || _error$cause === void 0 ? void 0 : _error$cause.errorType) !== 'NOT_FOUND') {
    Raven.captureException(new Error('Payment eligibility API failed'), {
      extra: {
        error
      }
    });
  }
  return {
    type: FETCH_PAYMENT_ELIGIBILITY_FAILED
  };
}
export const fetchPaymentsEligibility = () => dispatch => {
  dispatch(requestPaymentsEligibility());
  const success = resp => dispatch(receivePaymentsEligibility(resp));
  const error = resp => dispatch(receivePaymentsEligibilityFailure(resp));
  fetch().then(success, error).catch(err => {
    setTimeout(() => {
      throw err;
    });
  });
};